/**
 * This is a wrapper for the Material UI Button component to add Google Analytics tracking.
 */

import React from 'react';
import Button from '@mui/material/Button'; // eslint-disable-line no-restricted-imports
import { CircularProgress, Tooltip } from '@mui/material';
import { track } from '@common/analytics';

export default React.forwardRef(
  (
    {
      analytics,
      onClick,
      loading,
      startIcon,
      disabled,
      tooltipTitle,
      tooltipProps,
      ...props
    },
    ref
  ) => {
    const button = (
      <Button
        {...props}
        ref={ref}
        onClick={(...args) => {
          // eslint-disable-next-line no-unused-expressions
          analytics && track(...analytics);
          // eslint-disable-next-line no-unused-expressions
          onClick && onClick(...args);
        }}
        startIcon={(loading && <CircularProgress size="1rem" thickness={5} />) || startIcon}
        disabled={disabled || loading}
      />
    );
    return tooltipTitle ? (
      <Tooltip title={tooltipTitle} {...tooltipProps}>
        <span>{button}</span>
      </Tooltip>
    ) : (
      button
    );
  }
);
